import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

interface UserPlan {
  planType: string | null;
  creditsLimit: number;
  creditsUsed: number;
}

export const useUserPlan = () => {
  const { user } = useAuth();
  const [currentPlan, setCurrentPlan] = useState<UserPlan | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUserPlan = async () => {
      if (!user) {
        setLoading(false);
        return;
      }

      try {
        const { data, error: functionError } = await supabase.functions.invoke('get-plans');
        
        if (functionError) throw functionError;

        if (data?.currentPlan) {
          setCurrentPlan({
            planType: data.currentPlan, // currentPlan is already the plan type string
            creditsLimit: data.currentUsage?.monthly_limit || 0,
            creditsUsed: data.currentUsage?.monthly_used || 0,
          });
        }
      } catch (err) {
        console.error('Error fetching user plan:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch plan');
      } finally {
        setLoading(false);
      }
    };

    fetchUserPlan();
  }, [user]);

  return { currentPlan, loading, error };
};
